import {
  Box,
  FormControl,
  TextField,
  Typography,
  InputAdornment,
  IconButton
} from '@mui/material'
import { textBoxStyles } from '../../styles/classes/GeneralClasses'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons'

const TextBox = ({
  value,
  title,
  required,
  placeholder,
  onChange,
  name,
  error,
  small,
  onClear,
  disabled
}) => {
  const { classes } = textBoxStyles()
  let endAdornmentComponent = null
  if (onClear && value.length && !disabled) {
    endAdornmentComponent = (
      <InputAdornment position="start" sx={{ marginRight: '-10px' }}>
        <IconButton onClick={() => onClear(name)}>
          <FontAwesomeIcon icon={faCircleXmark} style={{ fontSize: 12 }} />
        </IconButton>
      </InputAdornment>
    )
  }

  return (
    <FormControl sx={{ width: '100%' }}>
      <Box className={classes.titleContainer}>
        {required && <Typography className={classes.titleSymbol}>*</Typography>}
        <Typography className={classes.titleFontStyle}>{title}</Typography>
      </Box>
      <TextField
        disabled={disabled}
        error={error}
        value={value}
        multiline={!small}
        className={`${classes.formDescription} ${
          small && classes.smallTextBox
        }`}
        name={name}
        variant="outlined"
        placeholder={placeholder}
        rows={small ? 1 : 4}
        onChange={onChange}
        InputProps={{
          className: classes.searchBar,
          endAdornment: endAdornmentComponent
        }}
      />
    </FormControl>
  )
}

export default TextBox
